import { CONNECTION_TYPE_DAV } from '../../DataConnections/dataConnection.types';
import {
    paramDsName,
    paramDsSubmit,
    paramOverwrite,
    paramUrl,
} from '../constants/parameterNames';
import {
    typeBoolean,
    typeDataConnection,
    typeDataSource,
} from '../constants/parameterTypes';
import { success } from '../helpers/commandResult';
import {
    getBoolParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';
import { getDataConnection } from '../helpers/qRules.dataConnection.helpers';
import { getDataSource } from '../helpers/qRules.dataSource.helpers';

const requiredParameters = [
    {
        name: paramDsSubmit,
        description: 'Submit Data Connection Name',
        type: typeDataConnection,
    },
];

const optionalParameters = [
    {
        name: paramDsName,
        description: 'Data Source Name',
        type: typeDataSource,
    },
    {
        name: paramOverwrite,
        description: 'Allow overwriting the target file',
        type: typeBoolean,
    },
    {
        name: paramUrl,
        description: 'Folder location to save',
    },
];

const description = 'Submits an XML document to a SharePoint form library.';

const executeAsync = async ({ dataSources, dataConnections, parameters }) => {
    const dsSubmitName = getParamValue(parameters, paramDsSubmit);

    const dsname = getParamValue(parameters, paramDsName);
    const overwrite = getBoolParamValue(parameters, paramOverwrite);
    const folderUrl = getParamValue(parameters, paramUrl);

    const inputDataSource = getDataSource(dataSources, dsname);
    const submitDataConn = getDataConnection(dataConnections, dsSubmitName);

    if (submitDataConn.type !== CONNECTION_TYPE_DAV) {
        throw new Error('Invalid connection type for dssubmit');
    }

    await submitDataConn.executeAsync({
        folderUrl,
        overwrite,
        xml: inputDataSource.getNode(),
    });

    return success();
};

const SubmitToSharePoint = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default SubmitToSharePoint;
